module.exports = __webpack_public_path__ + "static/media/pic_fenxing1.069cee34.png";